module.exports = __webpack_public_path__ + "img/depense.6a421e09.svg";